import KendoTooltipMixin from './KendoTooltipMixin'

export default {
    name: 'kendo-tooltip',
    mixins: [ KendoTooltipMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/index.js